let cartListPage = [];

document.addEventListener("DOMContentLoaded", (event) => {
  var waitForJQuery = setInterval(function () {
      if (typeof $ != 'undefined') {
  
        jQuery('.cart__page .cart__item').each(function (indexList, el) {
            let productName = jQuery(el).find('.itemName').text().trim();
            let productId =  jQuery(el).find('.itemId').text().trim();
            let productPrice = jQuery(el).find('.itemPrice').text().split('$')[1];
            let productQty = jQuery(el).find('.js-qty__num').val();
  
            cartListPage.push({
                index: indexList,
                item_name: productName,
                item_id: productId,
                price: productPrice,
                quantity: productQty
            })
        });
  
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        event: 'view_cart',
        ecommerce: {
            items: cartListPage
        }
        });

        jQuery('.btn.cart__checkout').click(function () {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
              items: cartListPage
          }
          });
      })
  
          clearInterval(waitForJQuery);
      }
  }, 10);
      
});



